export const HANDLE_SUBSCRIPTION = "HANDLE_SUBSCRIPTION"
export const SET_SHARE_SCREEN_BTN = "SET_SHARE_SCREEN_BTN"